import { useNavigate } from 'react-router-dom';
import { useState } from 'react';

import { MFASuccess } from './MFASuccess';
import { MFAChooseMethod } from './MFAChooseMethod';
import { MFAInstructions } from './MFAInstructions';
import { MFAScan } from './MFAScan';
import { Box } from '@mui/material';
import { MFA_TYPE } from '@common/types';
import useUserStore from 'store/user.store';
import { MFAContext } from './context';
import { MFAPhone } from './MFAPhone';

const STEP_LIMIT = 3;

const renderMFAAppStep = (step: number) => {
  switch (step) {
    case 1:
      return <MFAInstructions />;
    case 2:
      return <MFAScan />;
    case 3:
      return <MFASuccess />;
    case 0:
    default:
      return <MFAChooseMethod />;
  }
};

const renderMFASmsStep = (step: number) => {
  switch (step) {
    case 1:
      return <MFAPhone />;
    case 0:
    default:
      return <MFAChooseMethod />;
  }
};

export const MFA = () => {
  const [step, setStep] = useState<number>(0);
  const [mfaType, setMFAType] = useState<MFA_TYPE>(MFA_TYPE.APP);
  const { registerToken } = useUserStore();
  const navigate = useNavigate();

  if (!registerToken) {
    navigate('/auth/login');
  }

  const goToPreviousStep = () => {
    if (step > 0) {
      setStep(step - 1);
    }
  };

  const goToFirstStep = () => {
    setStep(0);
  };

  const goToNextStep = () => {
    if (step < STEP_LIMIT) {
      setStep(step + 1);
    }
  };

  const contextValues = {
    step,
    goToNextStep,
    goToFirstStep,
    goToPreviousStep,
    mfaType,
    setMFAType,
  };

  return (
    <MFAContext.Provider value={contextValues}>
      <Box
        sx={{
          height: '100%',
          display: 'flex',
          width: '100%',
          justifyContent: 'center',
          alignContent: 'center',
          alignItems: 'center',
        }}
      >
        {mfaType === 'sms' ? renderMFASmsStep(step) : renderMFAAppStep(step)}
      </Box>
    </MFAContext.Provider>
  );
};
